var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 618,
    viewBox: "0 0 1440 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.111111,
    d: "M-27.98 633.545C77.7619 612.71 194.8 589.128 418.323 563.314C641.845 537.501 719.541 527.322 852.501 497.492C985.461 467.662 1026.45 462.81 1316.46 446.781C1607.01 430.723 2015.65 340.062 2015.65 340.062",
    stroke: "url(#paint0_linear_22_1895)",
    strokeWidth: 1.11111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.222222,
    d: "M-53.3425 601.377C53.1472 579.51 170.992 554.541 396.805 535.058C622.618 515.574 701.063 507.033 834.822 474.208C968.581 441.383 1009.98 437.638 1303.65 437.976C1597.86 438.316 2008.99 338.928 2008.99 338.928",
    stroke: "url(#paint1_linear_22_1895)",
    strokeWidth: 1.22222
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.333333,
    d: "M-78.4507 568.664C28.8549 545.786 147.591 519.453 375.541 506.37C603.491 493.288 682.651 486.406 817.354 450.608C952.056 414.809 993.846 412.182 1290.68 429.008C1588.06 445.864 2002.12 337.814 2002.12 337.814",
    stroke: "url(#paint2_linear_22_1895)",
    strokeWidth: 1.33333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.444444,
    d: "M-103.291 535.408C4.89789 511.541 124.609 483.868 354.54 477.255C584.472 470.641 664.313 465.442 800.104 426.694C935.895 387.946 978.047 386.45 1277.56 419.87C1577.63 453.351 1995.04 336.715 1995.04 336.715",
    stroke: "url(#paint3_linear_22_1895)",
    strokeWidth: 1.44444
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.555556,
    d: "M-127.85 501.611C-18.7104 476.78 102.058 447.794 333.814 447.714C565.57 447.634 646.058 444.139 783.081 402.47C920.104 360.801 962.592 360.447 1264.3 410.556C1566.56 460.757 1987.75 335.625 1987.75 335.625",
    stroke: "url(#paint4_linear_22_1895)",
    strokeWidth: 1.55556
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.666667,
    d: "M-152.114 467.273C-41.9573 441.505 79.9505 411.235 313.373 417.75C546.795 424.264 627.894 422.494 766.292 377.938C904.69 333.381 947.487 334.181 1250.89 401.062C1554.85 468.066 1980.24 334.538 1980.24 334.538",
    stroke: "url(#paint5_linear_22_1895)",
    strokeWidth: 1.66667
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.777778,
    d: "M-176.07 432.398C-64.8303 405.721 58.2984 374.201 293.227 387.367C528.155 400.533 609.829 400.508 749.745 353.1C889.66 305.693 932.738 307.656 1237.35 391.382C1542.52 475.26 1972.52 333.449 1972.52 333.449",
    stroke: "url(#paint6_linear_22_1895)",
    strokeWidth: 1.77778
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.888889,
    d: "M-199.703 396.989C-87.3155 369.434 37.1146 336.696 273.387 356.568C509.66 376.439 591.873 378.179 733.448 327.961C875.022 277.744 918.353 280.882 1223.67 381.509C1529.55 482.321 1964.59 332.353 1964.59 332.353",
    stroke: "url(#paint7_linear_22_1895)",
    strokeWidth: 1.88889
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-223 84.0466C-109.401 55.6468 -3.50775 -19.6268 233.946 7.00058C471.4 33.6279 549.03 130.124 723.488 107.085C897.946 84.0466 910.419 58.4239 1215.95 176.001C1522.03 293.793 1956.45 54.2434 1956.45 54.2434",
    stroke: "url(#paint8_linear_22_1895)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_1895",
    x1: 2013.88,
    y1: 327.43,
    x2: 2018.08,
    y2: 357.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_1895",
    x1: 2006.7,
    y1: 320.251,
    x2: 2012.13,
    y2: 364.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_1895",
    x1: 1999.52,
    y1: 313.073,
    x2: 2005.68,
    y2: 371.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_1895",
    x1: 1992.34,
    y1: 305.894,
    x2: 1998.73,
    y2: 378.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_1895",
    x1: 1985.16,
    y1: 298.715,
    x2: 1991.28,
    y2: 386.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_1895",
    x1: 1977.99,
    y1: 291.537,
    x2: 1983.32,
    y2: 393.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_1895",
    x1: 1970.81,
    y1: 284.358,
    x2: 1974.87,
    y2: 400.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_1895",
    x1: 1963.63,
    y1: 277.179,
    x2: 1965.91,
    y2: 407.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_1895",
    x1: 1956.45,
    y1: 1.39111,
    x2: 1956.45,
    y2: 208.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#491EB8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.a8cede67b80017732d534f86a1dbbce8.svg";
export { ForwardRef as ReactComponent };